var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtokenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M811.4,695.5c0,42.5-13.2,77.6-39.5,105.2c-26.3,27.6-62.3,44.7-108,51v89.3h-83.7v-89.3 c-61.1-9-114.6-36.1-160.3-81.3l65.4-78.1c43.1,40.9,90.4,61.4,141.9,61.4c20.2,0,36.3-4.5,48.2-13.6c12-9,17.9-21.3,17.9-36.7 c0-16.5-6.8-29.7-20.3-39.5c-13.6-9.9-37-19.8-70.5-30c-21.5-7.4-39.1-13.5-52.8-18.2c-13.7-4.7-28.8-11.6-45.3-20.6 c-16.5-9-29.4-18.6-38.7-28.7c-9.3-10.1-17.1-23-23.5-38.7c-6.4-15.7-9.6-33.4-9.6-53c0-41.5,13-76.2,39.1-104.1 c26-27.9,62.2-44.5,108.5-49.8v-50.3l83.7-43.8v98.9c52.1,11.2,97.3,31.9,135.6,62.2l-63,78.9C693.9,436.9,653,422,613.7,422 c-20.2,0-35.9,4-47.1,11.9c-11.2,8-16.7,19.1-16.7,33.4c0,14.3,6.5,26,19.5,35c13,9,34.7,18.3,65.1,27.8 c30.5,11,54.8,19.8,73,26.4c18.2,6.6,36.2,16.1,54,28.6c17.8,12.5,30.6,27.6,38.3,45.4S811.4,670,811.4,695.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "386.4,829.1 254.8,829.1 254.8,508.4 386.4,435.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "985.4,829.1 853.8,829.1 853.8,172.9 985.4,100  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "203.6,829.1 72,829.1 72,639.7 203.6,566.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtokenWhite);
export default __webpack_public_path__ + "static/media/etoken_white.f64da8643fb6659c578580bab3219bd2.svg";
export { ForwardRef as ReactComponent };